import ajax from './ajax'

// 查询二级导航
export const querySn = (params) => {
  return ajax({
    url: '/public/v1/logistics/sn',
    params: params
  })
}

// 广告
export const queryAds = (params) => {
  return ajax({
    url: '/public/v1/logistics/ads',
    params: params
  })
}

// 查询二级导航
export const queryAttrParam = (params) => {
  return ajax({
    url: '/public/v1/logistics/attrparam',
    params: params
  })
}
// 查询属性
export const queryAttrValues = (params) => {
  return ajax({
    url: '/public/v1/logistics/attrvalues',
    params: params
  })
}
// 列表
export const queryList = (params) => {
  return ajax({
    url: '/public/v1/logistics/list',
    params: params
  })
}
export const doShare = (data) => {
  return ajax({
    method: 'post',
    url: '/public/v1/logistics/share',
    data: data
  })
}
export const queryNewsList = (params) => {
  return ajax({
    url: '/public/v1/logistics/news/list',
    params: params
  })
}
export const queryNewsDetail = (params) => {
  return ajax({
    url: '/public/v1/logistics/news/detail',
    params: params
  })
}
// 详情
export const queryDetail = (params) => {
  return ajax({
    url: '/public/v1/logistics/detail',
    params: params
  })
}
// 详情
export const queryI = (params) => {
  return ajax({
    url: '/public/v1/logistics/i',
    params: params
  })
}
// 详情
export const queryIList = (params) => {
  return ajax({
    url: '/public/v1/logistics/ilist',
    params: params
  })
}

// 留言
export const addMsg = (data) => {
  return ajax({
    method: 'post',
    url: '/public/v1/logistics/user/msg/add',
    data: {
      ...data,
      withToken: 1
    }
  })
}
export const querySendList = (data) => {
  return ajax({
    url: '/public/v1/logistics/user/msg/send',
    params: {
      ...data,
      withToken: 1
    }
  })
}
export const queryReceiveList = (data) => {
  return ajax({
    url: '/public/v1/logistics/user/msg/receive',
    params: {
      ...data,
      withToken: 1
    }
  })
}
// 企业新闻
export const queryCompNewsOne = (params) => {
  return ajax({
    method: 'get',
    url: '/public/v1/logistics/user/compnews/one',
    params: {
      ...params,
      withToken: 1
    }
  })
}
export const queryCompNewsList = (params) => {
  return ajax({
    method: 'get',
    url: '/public/v1/logistics/user/compnews/list',
    params: {
      ...params,
      withToken: 1
    }
  })
}
export const createCompnews = (data) => {
  return ajax({
    method: 'post',
    url: '/public/v1/logistics/user/compnews/create',
    data: {
      ...data,
      withToken: 1
    }
  })
}
export const modifyCompnews = (data) => {
  return ajax({
    method: 'post',
    url: '/public/v1/logistics/user/compnews/modify',
    data: {
      ...data,
      withToken: 1
    }
  })
}
export const deleteCompnews = (data) => {
  return ajax({
    method: 'post',
    url: '/public/v1/logistics/user/compnews/delete',
    data: {
      ...data,
      withToken: 1
    }
  })
}
// 用户沟通
export const doConnect = (data) => {
  return ajax({
    method: 'post',
    url: '/public/v1/logistics/user/connect',
    data: {
      ...data,
      withToken: 1
    }
  })
}
export const modifyConnectField = (data) => {
  return ajax({
    method: 'post',
    url: '/public/v1/logistics/user/changeConnectField',
    data: {
      ...data,
      withToken: 1
    }
  })
}
export const queryItemConnects = (params) => {
  return ajax({
    method: 'get',
    url: '/public/v1/logistics/user/itemConnects',
    params: {
      ...params,
      withToken: 1
    }
  })
}
export const queryUserConnects = (params) => {
  return ajax({
    method: 'get',
    url: '/public/v1/logistics/user/userConnects',
    params: {
      ...params,
      withToken: 1
    }
  })
}

// 用户新建、修改、详情
export const createUser = (data) => {
  return ajax({
    method: 'post',
    url: '/public/v1/logistics/user/create',
    data: {
      ...data,
      withToken: 1
    }
  })
}
export const modifyUser = (data) => {
  return ajax({
    method: 'post',
    url: '/public/v1/logistics/user/modify',
    data: {
      ...data,
      withToken: 1
    }
  })
}
export const queryUser = (params) => {
  return ajax({
    method: 'get',
    url: '/public/v1/logistics/user/info',
    params: {
      ...params,
      withToken: 1
    }
  })
}
// 企业信息
export const createComp = (data) => {
  return ajax({
    method: 'post',
    url: '/public/v1/logistics/user/comp/create',
    data: {
      ...data,
      withToken: 1
    }
  })
}
export const modifyComp = (data) => {
  return ajax({
    method: 'post',
    url: '/public/v1/logistics/user/comp/modify',
    data: {
      ...data,
      withToken: 1
    }
  })
}
export const queryComp = (params) => {
  return ajax({
    method: 'get',
    url: '/public/v1/logistics/user/comp/query',
    params: {
      ...params,
      withToken: 1
    }
  })
}

// 用户发布信息等接口
export const userCreateInfo = (data) => {
  return ajax({
    method: 'post',
    url: '/public/v1/logistics/user/base/create',
    data: {
      ...data,
      withToken: 1
    }
  })
}
export const userModifyInfo = (data) => {
  return ajax({
    method: 'post',
    url: '/public/v1/logistics/user/base/modify',
    data: {
      ...data,
      withToken: 1
    }
  })
}
export const userModifyField = (data) => {
  return ajax({
    method: 'post',
    url: '/public/v1/logistics/user/base/field',
    data: {
      ...data,
      withToken: 1
    }
  })
}
export const userModifyFieldList = (data) => {
  return ajax({
    method: 'post',
    url: '/public/v1/logistics/user/base/changefieldlist',
    data: {
      ...data,
      withToken: 1
    }
  })
}
export const userQueryInfoList = (params) => {
  return ajax({
    url: '/public/v1/logistics/user/base/list',
    params: {
      ...params,
      withToken: 1
    }
  })
}
export const userQueryInfoOne = (params) => {
  return ajax({
    url: '/public/v1/logistics/user/base/one',
    params: {
      ...params,
      withToken: 1
    }
  })
}



// WEBPACK FOOTER //
// ./src/axios/logistics.js